<template>
  <div>
    <input
      @keydown="handleKeyDown"
      @input="handleInput"
      @focus="focused"
      v-model="text"
      :id="getId()"
      :type="type"
      autocomplete="off"
      spellcheck="false"
      ref="input"
      maxlength="1"
      class="w-full text-center text-2xl font-bold bg-transparent py-2 outline-none text-grey-darkest"
    />
  </div>
</template>

<script>
import mixin from './../../mixin.js';

export default {
  name: 'digit-input-control',
  mixins: [mixin],
  props: {
    num: Number,
    length: Number,
    focus: Boolean,
    empty: Boolean,
    hidden: Boolean,
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      text: '',
      type: 'text',
    };
  },
  mounted() {
    this.type = this.hidden ? 'password' : 'text';
    this.text = this.value || '';
  },
  methods: {
    getId() {
      return `digit_${this.num}`;
    },
    setFocus() {
      this.$refs.input?.focus();
    },
    focused() {
      this.$emit('focused', this.num);
    },

    handleInput(e) {
      const val = e.target.value.replace(/\D/g, '');
      this.text = val;
      this.$emit('typing', { number: this.num, value: val });
    },

    handleKeyDown(e) {
      if (e.key === 'Backspace' || e.key === 'Delete') {
        if (this.num > 1 && !this.text) {
          this.$emit('prev', { number: this.num - 1 });
        }
        return;
      }

      if (e.key >= '0' && e.key <= '9') {
        e.preventDefault(); // prevent double entry
        this.text = e.key;
        this.$emit('typing', { number: this.num, value: e.key });

        if (this.num < this.length) {
          this.$emit('next', { number: this.num + 1 });
        }
      }
    },
  },
  watch: {
    focus(val) {
      if (val) this.setFocus();
    },
    empty(val) {
      if (val) this.text = '';
    },
    hidden(val) {
      this.type = val ? 'password' : 'text';
    },
    value(val) {
      this.text = val || '';
    },
  },
};
</script>

<style scoped>
.papsi-digit-input {
  font-family: 'Courier New', Courier, monospace;
}
</style>
